import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Feedback.css';

const Feedback = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [category, setCategory] = useState('general');
  const [message, setMessage] = useState('');
  const [rating, setRating] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null);

  const canSubmit = message.trim().length > 0 && !submitting;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;

    setSubmitting(true);
    setStatus(null);
    try {
      const payload = { category, message: message.trim() };
      if (rating > 0) payload.rating = rating;

      await axios.post('/api/feedback', payload, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
      });

      setStatus({ type: 'success', text: 'Thanks for your feedback!' });
      setMessage('');
      setCategory('general');
      setRating(0);
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem('auth_user');
        navigate('/login');
        return;
      }
      const errorMessage = error?.response?.data?.error || 'Unable to submit feedback. Please try again.';
      setStatus({ type: 'error', text: errorMessage });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="feedback-widget">
      {open && (
        <div className="feedback-modal" role="dialog" aria-modal="true" aria-label="Submit feedback">
          <div className="feedback-header">
            <h3>Share Feedback</h3>
            <button className="feedback-close" onClick={() => setOpen(false)} aria-label="Close feedback form">
              ✕
            </button>
          </div>

          <form onSubmit={handleSubmit} className="feedback-form">
            <label htmlFor="feedback-category">Category</label>
            <select
              id="feedback-category"
              value={category}
              onChange={(e) => setCategory(e.target.value)}
              className="feedback-input"
            >
              <option value="bug">Bug Report</option>
              <option value="feature">Feature Request</option>
              <option value="general">General</option>
            </select>

            <label htmlFor="feedback-message">Message</label>
            <textarea
              id="feedback-message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="feedback-input feedback-textarea"
              placeholder="Tell us what happened, what you expected, or what you'd like to see."
              required
            />

            <label htmlFor="feedback-rating-group">Rating (optional)</label>
            <div
              id="feedback-rating-group"
              className="feedback-stars"
              role="radiogroup"
              aria-label="Feedback rating"
            >
              {[1, 2, 3, 4, 5].map((star) => (
                <button
                  key={star}
                  type="button"
                  className={`feedback-star${rating >= star ? ' feedback-star--active' : ''}`}
                  onClick={() => setRating(star)}
                  role="radio"
                  aria-checked={rating === star}
                  aria-label={`${star} star${star > 1 ? 's' : ''}`}
                >
                  ★
                </button>
              ))}
            </div>

            <button type="submit" className="feedback-submit" disabled={!canSubmit}>
              {submitting ? 'Sending...' : 'Submit'}
            </button>

            {status && (
              <p className={`feedback-status feedback-status--${status.type}`} role="status">
                {status.text}
              </p>
            )}
          </form>
        </div>
      )}

      <button className="feedback-fab" onClick={() => setOpen((prev) => !prev)} title="Send feedback">
        {open ? '✕' : '📝'}
      </button>
    </div>
  );
};

export default Feedback;
